<div class="w-full p-8 max-w-6xl">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>Styrkir starfsfólks</h2>
    </div>
    <span class="separator-line block mb-[px]"></span>
    <br />
    <mat-tab-group class="sm:px-2 hjalp-tab-group fade-in-left" [animationDuration]="'0'"
        [(selectedIndex)]="selectedPanelIndex" (selectedTabChange)="tabChanged($event)">
        <mat-tab label="{{ 'label_register_request' | translate }}">
            @if (form) {
            <form [formGroup]="form" #ngRequestForm="ngForm">
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <ng-container>
                        <div class="col-span-4 mt-2 mb-2">
                            <mat-form-field class="w-full mb-4">
                                <mat-label>{{ 'label_type_support' | translate }}</mat-label>
                                <mat-select (selectionChange)="onTypeChange($event.value)" [formControlName]="'type'"
                                    placeholder="Tegund">
                                    @for (type of assistTypes; track type) {
                                    <mat-option [value]="type.value">
                                        {{ type.viewValue }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            @if (form.get('type').value == 'sjonvernd') {
                            <div class="col-span-4 radio-button-compact">
                                <mat-radio-group [formControlName]="'typeSight'"
                                    (change)="onTypeSightChange($event.value)">
                                    <mat-radio-button class="w-100 float-left pl-4"
                                        value="gleraugu">Gleraugnastyrkur</mat-radio-button>
                                    <mat-radio-button class="w-100 float-left pl-4 mt-1 mb-[20px]" value="laser">Styrkur
                                        vegna laseraðgerðar</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            }
                            @if (form.get('type')?.value) {
                            <fuse-alert [appearance]="'border'" [type]="'info'">
                                @if (form.get('type').value == 'likamsraekt') {
                                LSR styrkir starfsmenn sína til heilsuræktar um allt að {{ fitnessGrantAmount}} kr. á
                                ári. Til að fá styrkinn þurfa starfsmenn að framvísa reikningi og þarf hann að vera
                                gefin út á nafn starfsmanns. Styrkurinn reiknast sem 75% af framvísuðum reikningi.
                                Styrkurinn greiðist út með launum næstu mánaðarmót eftir að reikningur berst til
                                launafulltrúa. Með kostnaði við íþróttaiðkun og heilsurækt er átt við greiðslu á aðgangi
                                að líkamsræktarstöðvum, sundlaugum og skíðasvæðum, greiðslu á æfingagjöldum í
                                íþróttasali og félagsgjöldum í golfklúbba sem og þátttökugjöld vegna annarrar hreyfingar
                                sem stunduð er með reglubundnum hætti. Sótt er um styrk með því að skila inn reikningi
                                fyrir útlögðum kostnaði í gegnum beiðnakerfi sjóðsins á Mínum síðum LSR (mitt.lsr.is).
                                Starfsfólk Fjármálasviðs vinnur úr beiðnum um styrk og kemur þeim í greiðsluferli.
                                }
                                @if (form.get('type').value == 'sjonvernd') {
                                Þeir starfsmenn LSR sem þurfa á skjávinnugleraugum að halda við vinnu sína eiga kost á
                                því að fá hluta af kostnaði gleraugna greiddan eða að hámarki {{ visionGrantAmount }}
                                kr. ásamt komugjaldi til augnlæknis. Kjósi starfsmaður að fara í laseraðgerð er styrkur
                                LSR sem nemur einum og hálfum gleraugnastyrk. Til að fá styrkinn þurfa starfsmenn að
                                framvísa vottorði um þörf á gleraugum vegna skjávinnslu, auk reiknings sem gefin er út á
                                nafn starfsmanns. Styrkurinn er veittur einu sinni á þriggja ára fresti. Fyrir þá sem
                                eru félagsmenn <a matTooltip="Fara á vefslóð" href="https://www.sameyki.is/styrkir/"
                                    target="_blank">Sameykis</a> er styrkur frá
                                LSR háður því að gleraugnastyrkur Sameykis hafi einnig verið nýttur. Sótt er um
                                styrk með því að skila inn reikningi fyrir útlögðum kostnaði og vottorði í gegnum
                                beiðnakerfi sjóðsins á Mínum síðum LSR (mitt.lsr.is). Starfsfólk Fjármálasviðs vinnur úr
                                beiðnum um styrk og kemur þeim í greiðsluferli.
                                }
                                @if (form.get('type').value == 'simastyrkur') {
                                <span class="float-left mb-2">
                                    LSR veitir starfsfólki með ótímabundinn ráðningarsamning styrk til símakaupa á
                                    þriggja ára fresti. Kaupi starfsmaður síma áður en full þrjú ár eru liðin frá
                                    síðasta styrk er veittur hlutfallslegur styrkur þannig að ef liðið er eitt ár frá
                                    síðasta styrk er veittur 1/3 af styrkfjárhæð og 2/3 ef tvö ár eru liðin.
                                </span>
                                <span class="float-left mb-2">
                                    Sótt er um styrk með því að skila inn reikningi fyrir útlögðum kostnaði í gegnum
                                    beiðnakerfi sjóðsins á Mínum síðum LSR (mitt.lsr.is). Á reikningnum þarf að koma
                                    fram nafn og kennitala starfsmanns.
                                </span>
                                <span class="float-left">
                                    Starfsfólk Fjármálasviðs vinnur úr beiðnum um símastyrk og kemur þeim í
                                    greiðsluferli. Fjárhæðin tekur mið af nýjustu útgáfu af grunntýpu vinsælla síma.
                                    Símastyrkur fyrir árið {{ year }} er að hámarki {{ phoneGrantAmount }} kr.
                                    Starfsfólk getur við kaup á síma nýtt sér afsláttarkjör sjóðsins hjá Símanum með því
                                    að sækja Síminn Pay appið á
                                    <a matTooltip="Fara á vefslóð" href="https://app.siminnpay.is/activate?code=poplp5P"
                                        target="_blank">þessum hlekk</a>.
                                </span>
                                }
                            </fuse-alert>
                            }
                        </div>
                        <div class="col-span-4">
                            <div class="text-[14px] font-medium mb-1" [ngClass]="{
                                        'validation-error-color': form?.get('description')?.hasError('required') && submitted,
                                        'opacity-60': !formEnabled,
                                    }">
                                Helstu upplýsingar
                            </div>
                            <ckeditor [disabled]="form?.get('description')?.disabled" [editor]="descriptionEditor"
                                [(ngModel)]="descriptionTextHTML" name="descriptionTextHTML"
                                [ngModelOptions]="{ standalone: true }" [config]="editorConfig"
                                (ready)="onEditorReady($event)" (change)="descriptionOnChange($event)"
                                id="editorDescription"></ckeditor>
                            <mat-hint [innerHTML]="descriptionTooltip"></mat-hint>
                        </div>
                        <div class="col-span-4">
                            <ngx-dropzone class="custom-dropzone" class="justify-center" (change)="onSelect($event)"
                                [disabled]="this.form.disabled">
                                <ngx-dropzone-label>
                                    <div>
                                        <h2>
                                            {{ 'label_drag_attachment_if_applicable' | translate }}
                                        </h2>
                                        <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                    </div>
                                </ngx-dropzone-label>
                                @for (f of files; track f) {
                                <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                                }
                            </ngx-dropzone>
                        </div>
                    </ng-container>
                </div>
                <div class="flex items-center justify-end mt-[20px]">
                    @if (form.dirty) {
                    <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                        {{ 'label_cancel' | translate }}
                    </button>
                    }
                    <button class="ml-4" (click)="submit()" mat-flat-button type="submit" [color]="'primary'"
                        [disabled]="!formEnabled">
                        @if (formEnabled) {
                        <span>
                            {{ 'label_register_request' | translate }}
                        </span>
                        }
                        @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </form>
            }
        </mat-tab>
        <mat-tab label="{{ 'label_my_requests' | translate }}">
            @if (searchForm && lsrauthService.inRole(userDetails, userRoles.ADMIN_SEND_EMPLOYEE_SUPPORT_REQUESTS)) {
            <span>
                <public-registry-search label="{{ 'label_person' | translate }}"
                    (onOptionSelected)="optionSelected($event)" [autoSelectFullSSN]="false"></public-registry-search>
            </span>
            }
            <div>
                <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData"
                    class="w-[100%] mt-4">
                    <ng-container matColumnDef="key">
                        <th mat-sort-header="key" mat-header-cell *matHeaderCellDef>
                            {{ 'label_audkenni' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="c-link" target="_blank" matTooltip="{{ 'label_view_request_plain' | translate }}"
                                href="{{
                                    !lsrauthService.inRole(userDetails, userRoles.ADMIN_SEND_EMPLOYEE_SUPPORT_REQUESTS)
                                        ? element.url
                                        : 'https://lsr.atlassian.net/browse/' + element.key
                                }}">{{ element.key }}</a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="title">
                        <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                            {{ 'label_type' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="c-link" target="_blank" matTooltip="{{ 'label_view_request_plain' | translate }}"
                                href="{{
                                    !lsrauthService.inRole(userDetails, userRoles.ADMIN_SEND_EMPLOYEE_SUPPORT_REQUESTS)
                                        ? element.url
                                        : 'https://lsr.atlassian.net/browse/' + element.key
                                }}">{{ element.title }}</a>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="reporterName">
                        <th mat-sort-header="reporterName" mat-header-cell *matHeaderCellDef>
                            {{ 'label_registered_by' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span matTooltip="{{ 'label_registered_by' | translate }}">{{ element.reporterName }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="created">
                        <th mat-sort-header="created" mat-header-cell *matHeaderCellDef>
                            {{ 'label_registered_at_plain' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span matTooltip="{{ 'label_registered_at_plain' | translate }}">{{
                                formatDate(element.created) }}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="assistAllocationDate">
                        <th mat-sort-header="assistAllocationDate" mat-header-cell *matHeaderCellDef>
                            {{ 'label_given_at' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span matTooltip="{{ 'label_given_at' | translate }}">
                                @if (element.assistAllocationDate) {
                                {{ formatDate(element.assistAllocationDate) }}
                                }
                                @if (!element.assistAllocationDate) {
                                -
                                }
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="assistAmount">
                        <th mat-sort-header="assistAmount" mat-header-cell *matHeaderCellDef>
                            {{ 'label_amount_given' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span matTooltip="{{ 'label_amount_given' | translate }}">
                                @if (element.assistAmount) {
                                {{ element.assistAmount | translocoDecimal }}
                                ISK
                                }
                                @if (!element.assistAmount) {
                                -
                                }
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                            {{ 'label_status' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span
                                class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                                [ngClass]="{
                                    'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': element.status === 'Móttekið',
                                    'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': element.status === 'Hætt við',
                                    'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50':
                                        element.status !== 'Móttekið' &&
                                        element.status !== 'Hætt við' &&
                                        element.status !== 'Lokið' &&
                                        element.status !== 'Leyst',
                                    'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                        element.status === 'Lokið' || element.status === 'Leyst',
                                }">
                                <span class="leading-relaxed whitespace-nowrap">{{ element.status }}</span>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: orgRequestsColumns"></tr>
                    <tr class="mat-row" [ngClass]="{ 'h-0': isLoading }" *matNoDataRow>
                        @if (!isLoading && initialFetchComplete) {
                        <div class="flex items-center justify-between">
                            <span>
                                <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                    {{ 'info_requests_found_plain' | translate }}
                                </div>
                            </span>
                        </div>
                        }
                    </tr>
                </table>
                @if (isLoading) {
                <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                    <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-progress-spinner>
                    Sæki beiðnir
                </div>
                }
                @if (!isLastPage) {
                <div #sentinel class="h-1"></div>
                }
            </div>
        </mat-tab>
    </mat-tab-group>
</div>